import DefaultTextContainer from "./styles";
export default DefaultTextContainer;
